import {
  Compra,
  FiltroComprasRequest,
  FornecedorAdicionarRequest,
} from "../Components/Shared/Interfaces/Compra";
import { ServiceBase } from "./ServiceBase";

export class ComprasService extends ServiceBase {
  async listarCompras() {
    return this.get("/api/Compras/Buscar");
  }

  async adicionarCompra(body: Compra) {
    return this.post("/api/Compras/Adicionar", body);
  }

  async atualizarCompra(body: Compra) {
    return this.put("/api/Compras/Atualizar", body);
  }

  async removerCompra(compraId: number) {
    return this.delete(`/api/Compras/Deletar/${compraId}`);
  }

  async buscarPor(filtro: FiltroComprasRequest) {
    return this.post("/api/Compras/BuscarPor", filtro);
  }

  async buscarFornecedores() {
    return this.get("/api/Compras/BuscarFornecedores");
  }

  async adicionarFornecedor(body: FornecedorAdicionarRequest) {
    return this.post("/api/Compras/AdicionarFornecedor", body);
  }

  async atualizarFornecedor(
    id: number,
    body: { id: number; nome: string; cnpj: string }
  ) {
    return this.put(`/api/Compras/AtualizarFornecedor/${id}`, body);
  }
}

